export default __webpack_public_path__ + "static/media/DNo.9-4.5925bbee.jpg";